import type { FaireProductEntity } from "../../entity_types/product";

export const p_2qydwfphxj: FaireProductEntity = {
  token: "p_2qydwfphxj",
  type: "product",
  name: "Case-Mate Ivory Pearl Bow Jelly Tote Bag",
  brandToken: "b_7dpvor9hnj",
  brandName: "Case-Mate",
  imageUrl:
    "https://cdn.faire.com/fastly/592ac2f5b5f6a3f62da6cd28f49463c39d15005affcd98a45dfe5cbd582ba4a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d96965b53010329621724be3e7e138a4c808f1db9243d6ab2e8d8768c3f0850d.jpeg",
    "https://cdn.faire.com/fastly/ca0f7633e2382e8c02b070a64a2671c1ab6bdcc37eaf99115797b58bfe4fd913.jpeg",
    "https://cdn.faire.com/fastly/340d4c6b042e3c9a6fa1c1f0b25921862508b29564a35f4ea0b07b5cd60869d6.jpeg",
    "https://cdn.faire.com/fastly/0eae5335ccad49355b5f25e4c606cba532409a05f1bdf6d729171be8c99bb9dc.jpeg",
    "https://cdn.faire.com/fastly/c3dfc1e3c2229258f0883089cb9159b203e6931c7b3ba4834d3d08f7708827aa.jpeg",
    "https://cdn.faire.com/fastly/978bdd12a69914c0392ff79e2210903420266947e5e9daf263ec8a33bd9cc1be.jpeg",
    "https://cdn.faire.com/fastly/65ab20b4294b60e0cb0aabcb2a56456b9de3f9cd9d1a1db0eb171241ae08d246.jpeg",
    "https://cdn.faire.com/fastly/aaaca3779fd026c199626394c13468b888f5d6c04dec18f4c5d364b8eab0a424.jpeg",
    "https://cdn.faire.com/fastly/946d6c11e70c032e4b9b24d0f6d8b7dfa8c07a9cf4902872e5bd1815a3ea11c9.jpeg",
    "https://cdn.faire.com/fastly/4aa10665c32450679306e07ba3af9a7b033c79071c14bbf865b42e26e06295da.jpeg",
  ],
  priceDollars: 55,
  description:
    "Spacious yet lightweight, our Jelly Tote is designed to keep up with your day—from errands and work to beach trips and travel. It folds flat for easy packing as an extra bag or doubles as a roomy carry-on with space for your laptop, makeup bag, shoes, water bottle, and more. The wipeable material makes cleanup a breeze (even after coffee spills), while the extra-wide straps provide comfortable support, no matter how much you pack.\n\nKeep your essentials organized with the water-resistant phone pouch and secure it to the interior key leash so everything stays within easy reach. Fold it or fill it—this tote is ready when you are.\n\nPerfect for everyday use and your favorite hobbies, too—especially Mahjong nights, crafting sessions, book club, and more.",
  tags: [],
  msrpDollars: 110,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:38.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
